import { EtlTool } from '@elementary/common-ui/services/gql/types';

const ETL_TOOL_DISPLAY_NAME: Record<EtlTool, string> = {
  FIVETRAN: 'Fivetran',
};

export const getToolDisplayName = (toolType: EtlTool): string =>
  ETL_TOOL_DISPLAY_NAME[toolType] ?? toolType;
